<!--
 * @Author: mazhigang
 * @Date: 2023-07-03 17:43:22
 * @LastEditors: mazhigang
 * @LastEditTime: 2024-01-31 13:15:14
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>溢价管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">溢价管理</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="职业">
                  <el-select
                    v-model="ruleForm.career_type"
                    placeholder="请选择职业"
                    style="margin-right: auto"
                  >
                    <el-option label="全部" value="0"> </el-option>
                    <el-option
                      :label="item.title"
                      :value="item.id"
                      v-for="(item, index) in zhenshu"
                      :key="index"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="分类">
                  <el-select
                    v-model="ruleForm.type"
                    placeholder="请选择分类"
                    style="margin-right: auto"
                    @change="selectType"
                  >
                    <el-option
                      :label="item.title"
                      :value="item.id"
                      v-for="(item, index) in typeList"
                      :key="index"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="描述">
                  <el-select
                    v-model="ruleForm.notic"
                    placeholder="请选择描述"
                    style="margin-right: auto"
                  >
                    <el-option
                      :label="item.propDesc"
                      :value="item.propValue"
                      v-for="(item, index) in niticList"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-button
          type="primary"
          class="btn"
          style="margin-bottom: 16px"
          @click="add()"
          >添加</el-button
        >
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column label="省市" align="center" width="160">
            <template slot-scope="scope">
              <div v-if="scope.row.provinceCode == 100000">全国</div>
              <div v-else>{{ scope.row.province }}-{{ scope.row.city }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="detailValueName" label="描述" align="center">
          </el-table-column>
          <el-table-column label="分类" align="center">
            <template slot-scope="scope">
              {{ scope.row.typeName }}
            </template>
          </el-table-column>
          <el-table-column label="职业" align="center">
            <template slot-scope="scope">
              {{ scope.row.careerTypeName }}
            </template>
          </el-table-column>
          <el-table-column prop="customPremium" label="用户溢价" align="center">
            <template slot-scope="scope">
              {{ scope.row.customPremium * 100 }}%
            </template>
          </el-table-column>
          <el-table-column
            prop="bodyguardsPremium"
            label="保安溢价"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.bodyguardsPremium * 100 }}%
            </template>
          </el-table-column>
          <el-table-column
            prop="publishTime"
            label="发布时间"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column label="状态" align="center" width="80">
            <template slot-scope="scope">
              <span class="redColor" v-if="scope.row.status == 0">下架</span>
              <span class="greenColor" v-if="scope.row.status == 1">上架</span>
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            align="center"
            width="180"
            fixed="right"
          >
            <template slot-scope="scope">
              <div class="disAround">
                <div
                  class="operateBtn greenColor1"
                  @click="stop(scope.row)"
                  v-if="scope.row.status == 0"
                >
                  启用
                </div>
                <div
                  class="operateBtn redColor1"
                  @click="stop(scope.row)"
                  v-if="scope.row.status == 1"
                >
                  禁用
                </div>
                <div class="operateBtn" @click="handleEdit(scope.row)">
                  编辑
                </div>
                <div
                  class="operateBtn redColor1"
                  @click="deleteItem(scope.row)"
                >
                  删除
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.operateData(),
      ruleForm: {
        type: "",
        career_type: "",
        notic: "",
      },
      tableData: [],
      niticList: [],
      zhenshu: [],
      page: 1,
      pageSize: 10,
      total: 0,
      typeList: [],
    };
  },
  mounted() {
    this.getList();
    this.getData();
    this.getType();
  },
  methods: {
    getData() {
      let param = {
        page: 1,
        pageSize: 99999,
        queryParams: [
          {
            name: "prop_name",
            type: "input",
            value: "pricePremiumType_occupation",
          },
        ],
      };
      this.$axios
        .post(`/admapi/sys/conf/list`, param)
        .then(({ data }) => {
          this.zhenshu = JSON.parse(data.items[0].propValue);
        })
        .catch()
        .finally();
    },
    getType() {
      let param = {
        page: 1,
        pageSize: 99999,
        queryParams: [
          {
            name: "prop_name",
            type: "input",
            value: "pricePremiumType_premium_classification",
          },
        ],
      };
      this.$axios
        .post(`/admapi/sys/conf/list`, param)
        .then(({ data }) => {
          this.typeList = JSON.parse(data.items[0].propValue);
        })
        .catch()
        .finally();
    },
    selectType(val) {
      this.ruleForm.notic = "";
      let param = {
        key: "",
      };
      for (var i = 0; i < this.typeList.length; i++) {
        if (val == this.typeList[i].id) {
          param.key = this.typeList[i].lvKey;
        }
      }
      this.$axios
        .post(`/admapi/sys/conf/getConfsByKey`, param)
        .then(({ data }) => {
          let arr = [];
          for (var x = 0; x < data.length; x++) {
            let obj = {};
            obj.propDesc = JSON.parse(data[x].propDesc).title;
            obj.propValue = data[x].propValue;
            arr.push(obj);
          }
          this.niticList = arr;
        })
        .catch()
        .finally();
    },
    add() {
      this.$router.push("/premiumAdd");
    },
    handleEdit(val) {
      this.$router.push({
        path: "premiumAdd",
        query: {
          id: val.id,
        },
      });
    },
    resetForm() {
      this.ruleForm.career_type = "";
      this.ruleForm.type = "";
      this.ruleForm.notic = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        queryParams: [],
      };
      if (this.ruleForm.type != "") {
        param.queryParams.push({
          name: "type",
          type: "select",
          values: [{ itemKey: this.ruleForm.type }],
        });
      }
      if (this.ruleForm.career_type != "") {
        param.queryParams.push({
          name: "career_type",
          type: "select",
          values: [{ itemKey: this.ruleForm.career_type }],
        });
      }
      if (this.ruleForm.notic != "") {
        param.queryParams.push({
          name: "detail_value",
          type: "select",
          values: [{ itemKey: this.ruleForm.notic }],
        });
      }
      this.$axios
        .post(`/admapi/premium/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
    stop(val) {
      this.$confirm(val.status == 0 ? "是否启用" : "是否禁用", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            id: val.id,
            state: val.status == 0 ? 1 : 0,
          };
          this.$axios
            .post(`/admapi/premium/publish`, param)
            .then(({ data }) => {
              this.$message({
                message: val.status == 0 ? "禁用成功" : "启用成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    deleteItem(val) {
      this.$confirm("是否删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`/admapi/premium/delete/${val.id}`)
            .then(({ data }) => {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped></style>
